export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-200">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-14">
          <div className="w-full lg:w-[42%] flex justify-center">
            <div className="relative w-[220px] md:w-[260px]">
              <div className="absolute -inset-4 bg-accent-500/8 rounded-[40px] blur-xl"></div>
              <div className="relative bg-background-950 rounded-[32px] md:rounded-[40px] p-2.5 md:p-3 aspect-[9/16] overflow-hidden shadow-2xl shadow-black/30">
                <div className="w-full bg-background-800 rounded-t-[22px] md:rounded-t-[30px] h-5 md:h-6 flex items-center justify-center">
                  <div className="w-10 md:w-12 h-1 md:h-1.5 bg-background-600 rounded-full"></div>
                </div>
                <div className="bg-background-900 h-full rounded-b-[22px] md:rounded-b-[30px] flex flex-col items-center justify-center p-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-accent-500 rounded-2xl flex items-center justify-center mb-3">
                    <i className="ri-flashlight-line text-white text-lg md:text-xl"></i>
                  </div>
                  <span className="text-white font-bold text-sm md:text-base font-heading">爆料网</span>
                  <span className="text-white/40 text-xs mt-1">一手猛料 · 实时追踪</span>
                  <div className="mt-4 w-full space-y-2">
                    <div className="bg-accent-500/20 rounded-lg p-2 px-3">
                      <span className="text-accent-400 text-xs font-semibold">🔥 今日热榜</span>
                      <p className="text-white/60 text-[10px] mt-0.5">网红人设崩塌事件持续发酵</p>
                    </div>
                    <div className="bg-white/5 rounded-lg p-2 px-3">
                      <span className="text-white/50 text-xs font-semibold">🕵️ 独家追踪</span>
                      <p className="text-white/40 text-[10px] mt-0.5">顶流艺人合同纠纷新进展</p>
                    </div>
                    <div className="bg-white/5 rounded-lg p-2 px-3">
                      <span className="text-white/50 text-xs font-semibold">💬 热议话题</span>
                      <p className="text-white/40 text-[10px] mt-0.5">直播带货数据造假全解析</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full lg:w-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
              吃瓜不排队，爆料 APP 一手掌握
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 md:mb-5 space-y-2">
              <span className="block">· 实时推送最新爆料，重大猛料不错过</span>
              <span className="block">· 离线阅读模式，地铁通勤也能安心吃瓜</span>
              <span className="block">· 匿名投稿功能，保护每一位爆料人隐私安全</span>
            </p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-apple-fill text-base"></i>
                iPhone 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-foreground-300 text-foreground-700 font-semibold text-sm rounded-full hover:bg-foreground-50 transition-colors whitespace-nowrap"
              >
                <i className="ri-android-fill text-base"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}